// Médias et coordonnées pour les résultats premium du calculateur (Analyse Pro + Plan Alimentaire)

export const BODYUP = {
  logo: 'https://customer-assets.emergentagent.com/job_ff5e520a-600e-4b33-acab-53b3a459ee62/artifacts/qj8tlz82_BODY%20UP_logo%20neg.png',
  name: 'Body-Up Personal Training',
  address: "Route des Tattes d'Oie 95, 1260 Nyon",
  phone: '+41 78 604 44 23',
  email: 'info@body-up.ch',
  website: 'body-up.ch',
  instagram: '@body_up_personal_training',
};

export const PREMIUM_BG = {
  hero: 'https://static.prod-images.emergentagent.com/jobs/ce8bd254-bc86-4d6e-aa23-755a77604680/images/6890dd504fbffb87b07b30178a3a1ee0f654a0b4dd0fc4d4aa51ad36c6f446c4.png',
  macro: 'https://static.prod-images.emergentagent.com/jobs/ce8bd254-bc86-4d6e-aa23-755a77604680/images/06486fc027744730b799a2bba20fae53388569ea072fd24b26562e7b5281e7b0.png',
};

// Images de plats vérifiées (HTTP 200) par catégorie de repas
export const FOOD_IMAGES = {
  breakfast: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=800&q=70&auto=format&fit=crop',
  snack: 'https://images.unsplash.com/photo-1432139555190-58524dae6a55?w=800&q=70&auto=format&fit=crop',
  lunch: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800&q=70&auto=format&fit=crop',
  dinner: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=800&q=70&auto=format&fit=crop',
  bowl: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=70&auto=format&fit=crop',
  veggies: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=70&auto=format&fit=crop',
  grocery: 'https://images.unsplash.com/photo-1494859802809-d069c3b71a8a?w=800&q=70&auto=format&fit=crop',
  plate: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800&q=70&auto=format&fit=crop',
  recipe: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&q=70&auto=format&fit=crop',
  smoothie: 'https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?w=800&q=70&auto=format&fit=crop',
};

// Recettes : galerie d'images variées
export const RECIPE_IMAGES = [
  FOOD_IMAGES.plate,
  FOOD_IMAGES.bowl,
  FOOD_IMAGES.recipe,
  FOOD_IMAGES.dinner,
  FOOD_IMAGES.smoothie,
  FOOD_IMAGES.lunch,
  FOOD_IMAGES.breakfast,
  FOOD_IMAGES.veggies,
];

// Choisit une image selon les mots-clés d'un titre de repas/section
export const pickFoodImage = (title = '') => {
  const t = title.toLowerCase();
  if (/petit.?d[ée]jeuner|breakfast|matin/.test(t)) return FOOD_IMAGES.breakfast;
  if (/collation|snack|en.?cas/.test(t)) return FOOD_IMAGES.snack;
  if (/d[ée]jeuner|midi|lunch/.test(t)) return FOOD_IMAGES.lunch;
  if (/d[îi]ner|soir|dinner/.test(t)) return FOOD_IMAGES.dinner;
  if (/course|shopping|achat|liste/.test(t)) return FOOD_IMAGES.grocery;
  if (/l[ée]gume|veg/.test(t)) return FOOD_IMAGES.veggies;
  if (/smoothie|shake|boisson/.test(t)) return FOOD_IMAGES.smoothie;
  return FOOD_IMAGES.plate;
};
